import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "./DashboardLayout";
import { FaIndustry, FaHome, FaPhone, FaMailBulk } from "react-icons/fa";
import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import SelectLike from "../components/SelectLike";
import L from "leaflet";

// آیکون پیش‌فرض Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

// حدود تقریبی ایران برای نمای کلی
const IRAN_BOUNDS = L.latLngBounds([24.3, 44.0], [39.9, 63.5]);
const IRAN_CENTER = [32.5, 54.5];

// ✅ لیست شعب
const BRANCHES = [
  {
    id: "factory",
    tag: "factory",
    name: "کارخانه",
    lat: 36.404946430381656,
    lng: 52.32469584537446,
    address: "مازندران، آمل، شهرک صنعتی امام زاده عبدالله، فاز 1، نبش لاله 4",
    postalCode: "46161-59635",
    phones: ["011-44203345", "011-44045"],
  },
  {
    id: "hq",
    tag: "hq",
    name: "دفتر مرکزی (المپیک)",
    lat: 35.74345594397778,
    lng: 51.26263499427787,
    address: "میدان المپیک، بلوار دهکده المپیک، خیابان شهید افشارنجفی، پلاک 44",
    postalCode: "1485874418",
    phones: ["021-44178407"],
  },
  {
    id: "tehran-sales-fath",
    tag: "sales",
    name: "شعبه تهران (فتح)",
    lat: 35.67985621358075, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    lng: 51.29086276821565, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    address: "خیابان فتح، فتح 25، پلاک 27",
    postalCode: "1387643651",
    phones: ["021-66806038"],
  },

  {
    id: "Kahrizak-sales-fath",
    tag: "sales",
    name: "شعبه تهران (کهریزک)",
    lat: 35.48378887371959, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    lng: 51.35082941475082, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    address: "بلوار امام حسین",
    postalCode: "",
    phones: [""],
  },

  {
    id: "tabriz-sales",
    tag: "sales",
    name: "شعبه تبریز",
    lat: 38.0595762884497, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    lng: 46.22917801143232, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    address: "میدان جانبازان، ساختمان بلور، طبقه 3",
    postalCode: "",
    phones: [""],
  },
  {
    id: "qazvin-sales",
    tag: "sales",
    name: "شعبه قزوین",
    lat: 36.18931739987662, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    lng: 50.076565840914526, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    address:
      "شهرک صنعتی البرز، بلوار میرداماد غربی، بالاتر از شرکت بیمه تامین اجتماعی، تالار البرز سابق",
    postalCode: "",
    phones: [""],
  },
  {
    id: "kermanshah-sales",
    tag: "sales",
    name: "شعبه کرمانشاه",
    lat: 34.35308599926523, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    lng: 47.09337338275367, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    address:
      "بلوار زن، ابتداب بلوار آل آقا(گذرنامه)،جنب جگری چاوان، ساختمان سارینا،طبقه 2،",
    postalCode: "",
    phones: [""],
  },
  {
    id: "lorestan2-sales",
    tag: "sales",
    name: "شعبه لرستان ",
    lat: 33.89590234850412, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    lng: 48.75314760026893, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    address:
      "خیابان شهدا، چهارراه حافظ، ابتدای حافظ جنوبی، کوچه درمانگاه امام سجاد",
    postalCode: "",
    phones: [""],
  },
  {
    id: " hamedan-sales",
    tag: "sales",
    name: "شعبه همدان",
    lat: 34.78365907450952, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    lng: 48.511850898026914, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    address: "میدان جهاد، برج زاگرس، طبقه 6، واحد 603",
    postalCode: "",
    phones: [""],
  },
  {
    id: " ardebil-sales",
    tag: "sales",
    name: "شعبه اردبیل",
    lat: 38.24099535047858, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    lng: 48.27896098155409, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    address:
      "چهار راه حافظ به سمت سه راه دانش،جنب بانک توسعه تعاون، ساختمان عرشیا،طبقه 2",
    postalCode: "",
    phones: [""],
  },
  {
    id: " babol-sales",
    tag: "sales",
    name: "شعبه بابل",
    lat: 36.53534646879965, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    lng: 52.71989651990021, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    address: "شهرک صنعتی منصور کنده بعد میدان صنعت خیابان مهستان شرکت هراز",
    postalCode: "",
    phones: [""],
  },
  {
    id: " mazandaran-sales",
    tag: "sales",
    name: "شعبه مازندران",
    lat: 36.57433693978056, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    lng: 52.30061725751231, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    address: "شهرک صنعتی تشبندان، شرکت لارین لبن",
    postalCode: "",
    phones: [""],
  },
  {
    id: " kerman-sales",
    tag: "sales",
    name: "شعبه کرمان",
    lat: 30.30423915837711, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    lng: 57.061905229550426, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    address: "خیابان شهید رجایی، بلوار جانباز، طبقه بالای پوشاک ایرانیان",
    postalCode: "",
    phones: [""],
  },

  {
    id: " isfahan-sales",
    tag: "sales",
    name: "شعبه اصفهان",
    lat: 32.62913269413472, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    lng: 51.626298681962474, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    address: "خیابان سهروردی، روبروی باغ زیار، نبش کوچه گلستان، پلاک 104",
    postalCode: "817694384",
    phones: [""],
  },
  {
    id: " shiraz-sales",
    tag: "sales",
    name: "شعبه شیراز",
    lat: 29.58462931152533, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    lng: 52.507371457418735, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    address: "خیابان عدالت جنوبی، نبش کوچه 35، ساختمان سمند،طبقه 7، واحد 8",
    postalCode: "7167618183",
    phones: [""],
  },
  {
    id: " bushehr-sales",
    tag: "sales",
    name: "شعبه بوشهر",
    lat: 28.922449921655915, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    lng: 50.877902490570094, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    address: "رو به روی تنگک دوم، خیابان صنعت، فرعی دوم سمت چپ پلاک 16، شرکت فراورده های لبنی دوشه آمل",
    postalCode: "",
    phones: [""],
  },
  {
    id: " karaj-sales",
    tag: "sales",
    name: "شعبه کرج",
    lat: 35.758672166228976, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    lng: 50.980495461079435, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    address: "جاده ملارد،خیابان فرگاز، بنفشه غربی، پلاک 551",
    postalCode: "",
    phones: [""],
  },
  {
    id: " Amol1-sales",
    tag: "sales",
    name: "شعبه آمل1",
    lat: 36.53797330264832, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    lng: 52.35877093384693, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    address: "جاده اوجی آباد به سیاهکلا نرسیده به روستای سعدینکلا،جنب شالیکوبی رنجبر ",
    postalCode: "4615310004",
    phones: [""],
  },
  {
    id: " Amol2-sales",
    tag: "sales",
    name: "شعبه آمل2",
    lat: 36.49554999773421, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    lng: 52.36425138898784, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    address: "کمربندی هزارسنگر به محمودآباد روبروی سی ان جی ذبیحی،انتهای راه و ترابری،50متر بسمت هزارسنگر",
    postalCode: "4615949111",
    phones: [""],
  },
  {
    id: " Gorgan-sales",
    tag: "sales",
    name: "شعبه گرگان",
    lat: 36.83014880069754, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    lng: 54.44225862190112, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    address: "خیابان شالیکوبی- پاساژ مروارید طبقه دوم -پلاک 3",
    postalCode: "",
    phones: [""],
  },

  {
    id: " Sari-sales",
    tag: "sales",
    name: "شعبه ساری",
    lat: 36.57120156058809, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    lng: 53.005660996263295, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    address: "کیلومتر3 جاده ساری به جویبار، روستای آبکسر جنب عبور اول مفتی کلا کنار نهالستان افرا",
    postalCode: "",
    phones: [""],
  },

  {
    id: " Chalus-sales",
    tag: "sales",
    name: "شعبه چالوس",
    lat: 36.659522937751845, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    lng: 51.44065012561717, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    address: "خیابان آیت اله غفاری(دهگیری) ، رو به روی ظفر 38",
    postalCode: "",
    phones: [""],
  },

  {
    id: " Ahvaz-sales",
    tag: "sales",
    name: "شعبه اهواز",
    lat: 31.325084357531864, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    lng: 48.65757957852202, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    address: "کمپلو شمالی، خیابان لشکر، روبه روی سازمان برق، دفتر فروش لبنیاتی هراز",
    postalCode: "",
    phones: [""],
  },

  {
    id: " Yazd-sales",
    tag: "sales",
    name: "شعبه یزد",
    lat: 31.854547366906004, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    lng: 54.373158644147225, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    address: "بلوار دانشجو، کوچه بیست و یکم(شهید محی الدینی)، ساختمان ارغوان، طبقه دوم",
    postalCode: "",
    phones: [""],
  },
  {
    id: " Rasht-sales",
    tag: "sales",
    name: "شعبه رشت",
    lat: 37.277677908812684, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    lng: 49.67850891012778, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    address: "بلوار امام رضا،کیلومتر 5 جاده رشت به لاهیجان،دارسازی،20 متر بعد از پل هوایی" ,
    postalCode: "",
    phones: [""],
  },

  {
    id: " Ramsar-sales",
    tag: "sales",
    name: "شعبه رامسر",
    lat: 36.92825273546009, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    lng: 50.64541569613158, // ← مختصات دقیق را در صورت نیاز جایگزین کن
    address: "خیابان شهدا، روبه روی کشتارگاه" ,
    postalCode: "",
    phones: [""],
  },

 
];

// کارت شعبه
function BranchCard({ icon, title, address, postalCode, phones }) {
  return (
    <div className="bg-white border rounded-md p-4 shadow flex flex-col justify-between">
      <div>
        <div className="flex items-center mb-2">
          {icon}
          <h3 className="font-bold text-blue-800 text-base">{title}</h3>
        </div>
        <p className="text-sm text-gray-700 mb-4">{address}</p>
      </div>
      <div className="mt-auto text-gray-700 text-sm space-y-1">
        {postalCode ? (
          <div className="flex items-center">
            <FaMailBulk className="ml-2 text-blue-700" />
            <span>کد پستی: {postalCode}</span>
          </div>
        ) : null}
        {(phones || []).map((ph, i) => (
          <div key={i} className="flex items-center">
            <FaPhone className="ml-2 text-blue-700" />
            <span>{ph}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

// کنترلر پرواز/زوم روی نقشه
function FlyToController({ selectedId, branches }) {
  const map = useMap();

  React.useEffect(() => {
    if (!map) return;

    // روی «همه شعب» → همیشه نمای کلی ایران
    if (selectedId === "all") {
      // زوم اولیهٔ بازتر ولی نزدیک‌تر از قبل (مثلاً 7)
      map.flyTo(IRAN_CENTER, 5, { duration: 0.8 });
      setTimeout(() => map.invalidateSize(), 0);
      return;
    }

    // پرواز روی شعبهٔ انتخاب‌شده
    const b = branches.find((x) => x.id === selectedId);
    if (b && Number.isFinite(b.lat) && Number.isFinite(b.lng)) {
      map.flyTo([b.lat, b.lng], 15, { duration: 0.8 });
    }
  }, [selectedId, branches, map]);

  return null;
}

const ContactUs = () => {
  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState("all");

  // برای نمایش مارکرها (اگر خواستی به‌جای IRAN_BOUNDS از bounds مارکرها استفاده کنی)
  const bounds = useMemo(() => {
    const points = BRANCHES.filter(
      (b) => Number.isFinite(b.lat) && Number.isFinite(b.lng)
    ).map((b) => [b.lat, b.lng]);
    return points.length ? L.latLngBounds(points) : undefined;
  }, []);

  // سه کارت بالا
  const factory = BRANCHES.find((b) => b.tag === "factory");
  const hq = BRANCHES.find((b) => b.tag === "hq");
  const tehranSales = BRANCHES.find((b) => b.tag === "sales");

  return (
    <DashboardLayout>
      {/* هدر */}
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-base sm:text-lg md:text-xl font-bold text-blue-700">
          ارتباط با ما
        </h1>
        <button
          onClick={() => navigate(-1)}
          className="px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded"
        >
          بازگشت
        </button>
      </div>

      {/* کارت‌ها */}
      <div className="grid md:grid-cols-2 gap-6 mt-6">
        {factory && (
          <BranchCard
            icon={<FaIndustry className="text-blue-700 ml-2" />}
            title={factory.name}
            address={factory.address}
            postalCode={factory.postalCode}
            phones={factory.phones}
          />
        )}
        {hq && (
          <BranchCard
            icon={<FaHome className="text-blue-700 ml-2" />}
            title={hq.name}
            address={hq.address}
            postalCode={hq.postalCode}
            phones={hq.phones}
          />
        )}
        {/* {tehranSales && (
          <BranchCard
            icon={<FaHome className="text-blue-700 ml-2" />}
            title={tehranSales.name}
            address={tehranSales.address}
            postalCode={tehranSales.postalCode}
            phones={tehranSales.phones}
          />
        )} */}
      </div>

      {/* دراپ‌داون انتخاب شعبه */}
      {/* <div className="mt-8 mb-2 flex items-center gap-2" dir="rtl">
        <label htmlFor="branchSelect" className="text-sm text-gray-700">
          انتخاب شعبه:
        </label>
        <select
          id="branchSelect"
          value={selectedId}
          onChange={(e) => setSelectedId(e.target.value)}
          className="border border-gray-300 rounded px-2 py-1 text-sm w-64 focus:outline-none"
        >
          <option value="all">همه شعب</option>
          {BRANCHES.map((b) => (
            <option key={b.id} value={b.id}>
              {b.name}
            </option>
          ))}
        </select>
      </div> */}

      <div className="mt-8 mb-2 flex items-center gap-2" dir="rtl">
        <label className="text-sm text-gray-700">انتخاب شعبه:</label>
        <SelectLike
          options={[
            { id: "all", name: "همه شعب" },
            ...BRANCHES.map((b) => ({ id: b.id, name: b.name })),
          ]}
          value={selectedId}
          onChange={(id) => setSelectedId(id)}
          maxVisible={10} // ← وقتی بیشتر از ۱۰ تا باشه، لیست اسکرول می‌خوره
          placeholder="انتخاب کنید"
          className="w-64"
          dir="rtl"
        />
      </div>

      {/* نقشه */}
      <div className="w-full h-[400px] rounded-xl overflow-hidden shadow">
        <MapContainer
          style={{ width: "100%", height: "100%" }}
          center={[32, 53]} // نقطه‌ای نزدیک مرکز ایران برای رندر اولیه
          zoom={6} // زوم مناسب برای ایران
          scrollWheelZoom
          maxBounds={IRAN_BOUNDS} // جلوگیری از خروج زیاد از ایران (اختیاری)
          maxBoundsViscosity={0.8}
        >
          <TileLayer
            attribution='&copy; <a href="https://osm.org">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

          {/* کنترل کننده زوم/پرواز */}
          <FlyToController selectedId={selectedId} branches={BRANCHES} />

          {/* مارکرها (بدون Popup) */}
          {BRANCHES.map((b) => (
            <Marker key={b.id} position={[b.lat, b.lng]} />
          ))}
        </MapContainer>
      </div>
    </DashboardLayout>
  );
};

export default ContactUs;
